// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ElecMonitorV2_wrapper__2b-2W","content":"ElecMonitorV2_content__3Mo6W"};